module.exports = {"pageHeader":"About Deveo"}


//////////////////
// WEBPACK FOOTER
// ./src/app/about/lang/en.lang.json
// module id = 332
// module chunks = 1